<div appModal class="text-center" (closeModal)="close()">
  <div class="bounce mt-32">
    <svg-icon src="assets/images/svg/icons/misc/download-modal.svg"></svg-icon>
  </div>
  <h3 class="message mt-15 mb-48">{{ message }}</h3>
</div>
